import { Flex, GridItem, IconButton } from "@chakra-ui/react";
import { FaPen, FaTrash } from "react-icons/fa";
import { EsgLabel } from "../../../../../../components/Forms";

function CategoryGridItems({ items, attributesOrder, handleEditItem, handleDeleteItem, isPreview }) {
  return (
    items && items.map(field => {
      const gridItems = [];

      // Putting the grid items in the same order as it's defined in attributesOrder
      attributesOrder.forEach(attribute => {
        const labelItem = (
          <EsgLabel overflow="hidden" text={field[attribute]} title={field[attribute]} />
        );
        gridItems.push(labelItem);
      });

      if (!isPreview) {
        // Adding row actions buttons in case if it's not in preview mode
        gridItems.push(<Flex>
          <IconButton
            type="button"
            icon={<FaPen size="16" />}
            width="100%"
            variant="ghost"
            color={"esg_green"}
            onClick={() => handleEditItem(field)}
          />
          <IconButton
            type="button"
            icon={<FaTrash size="16" />}
            width="100%"
            variant="ghost"
            color={"esg_red"}
            onClick={() => handleDeleteItem(field)}
          />
        </Flex>);
      }

      return gridItems.map((gridItem, gridItemIndex) => {
        // Total number of columns is sum of the number of attributes and action column (if it's not in preview)
        const numberOfColumns = attributesOrder.length + (!isPreview ? 1 : 0);

        return <GridItem
          key={`category-grid-item-${gridItemIndex}`}
          borderWidth={"1px"}
          pl="4" pr="4" pt="2" pb="2"
          display="flex"
          alignItems="center"
          colSpan={isPreview ? 2 : gridItemIndex === numberOfColumns - 1 ? 1 : 2}
        >
          {gridItem}
        </GridItem>;
      });
    })
  );
}

export default CategoryGridItems;